var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"APPOINTMENT-LIST-ITEM-PLACEHOLDER"},[_vm._m(0),_c('div',{staticClass:"d-flex flex-1-1 fd-column p-l-2"},[_c('job-list-item-placeholder'),_c('span',{staticClass:"x-pulse WIDE-PLACEHOLDER"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TIME"},[_c('span',{staticClass:"x-pulse PLACEHOLDER"}),_c('span',{staticClass:"x-pulse PLACEHOLDER"})])
}]

export { render, staticRenderFns }